import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector } from 'redux-form';
import Form from '../../components/forms/FinancialinstitutionsForm';
import { saveFinancialinstitutions, deleteFinancialinstitutions, withRedirect } from '../../CroActions';
import { push } from 'react-router-redux';
import { isLegitimate } from '../../CroUtils';
import { breadcrumbs } from '../../../../actions/appActions';

const selector = formValueSelector('financialinstitutionsForm');

const mapStateToProps = (state, { params, auth }) => ({
  breadcrumbsItems: [{ label: 'Finanční instituce' }, { label: 'Editace finanční instituce' }],
  loginData: { name: selector(state, 'name') },
  allowBasic: selector(state, 'allowBasic'),
  url: `${auth.startUrl}/api/financni-instituce/${params.id}`,
  disabled: isLegitimate(auth),
});

const onSubmit = url => withRedirect(saveFinancialinstitutions(url), `${url}/financni-instituce`);
const onDelete = (url, id) => async (dispatch) => {
  await deleteFinancialinstitutions(url, id)(dispatch);
  dispatch(push(`${url}/financni-instituce`));
};

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ onSubmit: onSubmit(props.auth.startUrl), breadcrumbs }, dispatch),
  onDelete: () => dispatch(onDelete(props.auth.startUrl, props.params.id)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Form);
